import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
export interface CreateReportSchedulerTemplateState {
  isLoading: boolean
  error: string | undefined
  httpStatus: number | undefined
}

const initialState: CreateReportSchedulerTemplateState = {
  isLoading: false,
  error: undefined,
  httpStatus: undefined
}

const createReportSchedulrTemplateSlice = createSlice({
  name: 'ReportSchedulerTemplate-Create',
  initialState,
  reducers: {
    createReportSchedulerTemplateLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        httpStatus: 0
      }
    },
    createReportSchedulerTemplateUpdateAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: undefined,
        httpStatus: action.payload
      }
    },
    createReportSchedulerTemplateErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  createReportSchedulerTemplateLoadingAction,
  createReportSchedulerTemplateUpdateAction,
  createReportSchedulerTemplateErrorAction
} = createReportSchedulrTemplateSlice.actions

export default createReportSchedulrTemplateSlice.reducer
